import {Component, Input, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';


@Component( {
	selector: 'app-event-unsubscribe-confirmation-dialog',
	templateUrl: './event-unsubscribe-confirmation-dialog.component.html',
} )
export class EventUnsubscribeConfirmationDialog {


	constructor(
		public dialogRef: MatDialogRef<EventUnsubscribeConfirmationDialog>
	) {}


}
